import Staffs from "../components/Staff/Staffs";
import Staff from "../components/Staff/Staff";
import {PERM} from "../utilites/permissions";

const staffs = [
  {
    path: '/staffs',
    name: 'Staffs',
    component: Staffs,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
      ]
    },
    props: true,
  },
  {
    path: '/staffs/new',
    name: 'StaffAdd',
    component: Staff,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
        PERM.STAFF_EDIT,
      ]
    },
    props: true
  },
  {
    path: '/staffs/edit/:id',
    name: 'StaffEdit',
    component: Staff,
    meta: {requiresAuth: true,
      permissions: [
        PERM.STAFF,
        PERM.STAFF_EDIT,
      ]
    },
    props: true
  },
];

export default staffs;



// WEBPACK FOOTER //
// ./src/router/staffs.js